const t = {
  name: "Number6",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 11V17H9V7H15V9H11V11H15ZM13 13H11V15H13V13Z" fill="currentColor"/>
<path d="M1 12C1 5.92772 5.92772 1 12 1C18.0723 1 23 5.92772 23 12C23 18.0723 18.0723 23 12 23C5.92772 23 1 18.0723 1 12ZM12 3C7.03228 3 3 7.03228 3 12C3 16.9677 7.03228 21 12 21C16.9677 21 21 16.9677 21 12C21 7.03228 16.9677 3 12 3Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Number6
};
